import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connectwithus',
  templateUrl: './connectwithus.component.html',
  styleUrls: ['./connectwithus.component.scss']
})
export class ConnectwithusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
